/**
 * Csv Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'

/* TODO: review generated schema */
export class CsvOcorrenciaTrackingResponsavelSchema extends Schema {
  readonly name = 'CsvOcorrenciaTrackingResp'

  readonly fieldSet: FieldSet<OcorrenciaTrackingResponsavel> = {
    idOcorrenciaTrackingResponsavelPk: schema =>
      schema.model.idOcorrenciaTrackingResponsavelPk,
    idResponsavelFk: schema => schema.model.idResponsavelFk,
    cnpj: schema => Helper.cnpj(schema.model.responsavel?.cnpj) || '',
    razaoSocial: schema => schema.model.responsavel?.razaoSocial || '',
    idOcorrenciaExterna: schema => schema.model.idOcorrenciaExterna,
    descricao: schema => schema.model.descricao,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
